import React, { useEffect } from 'react'

import { Grid } from 'lese'

import Sidebar from 'Components/Sidebar'
import Viewer from 'Components/Viewer'

import { useStore } from 'laco-react'
import EncountersStore, { updateEncounters } from 'Store/encounters'
import { updateUserStore } from 'Store/user'
import { connectWebsocket } from 'Store/websockets'

export default () => {
  const { selectedHl7Id, viewType } = useStore(EncountersStore)

  useEffect(async () => {
    await updateUserStore()
    await updateEncounters()

    await connectWebsocket()
  }, [])

  return (
    <Grid columns="450px 1fr" rows="auto 1fr" height="100%">
      <Sidebar />
      <Viewer selectedHl7Id={selectedHl7Id} viewType={viewType} />
    </Grid>
  )
}
